import React, {useEffect, useState} from "react"
import {Form, Radio, RadioChangeEvent} from "antd"
import AddressInput from "../../../components/FormItems/AddressInput";
import {CustomInput} from "../../../components/Custom/Input";
import {useTranslation} from "react-i18next";
import apiUser from "../../../api/user";
import {setFormErrors} from "../../../api/types";
import {getUserTypes} from "../../../store/actions/user";

const Company = (props: any) => {
    const { form, isLegalEntityRB, isNotToChange } = props
    const [hasUnp, setHasUnp] = useState(isLegalEntityRB)
    const {t} = useTranslation(['resources', 'translation'])
    const user = props.user ? props.user : {}

    useEffect(() => {
        if (isLegalEntityRB) {
            setHasUnp(true)
            form.setFieldsValue({hasUnp: true})
        } else {
            setHasUnp(false)
            form.setFieldsValue({hasUnp: false, unp: null})
        }
    }, [isLegalEntityRB])

    const getOrgByUnp = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value as string
        if (value.match(/\d{9}/g)) {
            apiUser.getOrgByUnp(value)
                .then((res) => {
                    if (res.code === 200) {
                        form.setFieldsValue({nameUl: res.data});
                    }
                    if (res.code === 404) {
                        form.setFields([{name: 'unp', errors:[res?.message]}])
                        form.setFieldsValue({nameUl: ''});
                    }
                }).catch(err => {setFormErrors(err, form)})
        }
    }

    const radioHasUnpChange = (e: RadioChangeEvent) => {
        let value = e.target.value
        setHasUnp(value)
        if(!value) {
            form.setFieldsValue({unp: null})
        }
    }

    return (
        <>
            <Form.Item
                hidden={isLegalEntityRB}
                name="hasUnp"
                label={t('RegisterViewModelHasUnp')}
                initialValue={isLegalEntityRB}
                className="new-block"
            >
                <Radio.Group onChange={radioHasUnpChange}>
                    <Radio value={true}>
                        {t('Yes')}
                    </Radio>
                    <Radio value={false}>
                        {t('No')}
                    </Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item
                hidden={!hasUnp}
                label={t('AppUserUnp')}
                name="unp"
                normalize={(value) => (value ? value.trim() : value)}
                rules={[
                    {
                        required: hasUnp,
                        pattern: /^\d{9}$/,
                        message: t('validation:ValidateUnp')
                    }
                ]}
            >
                <CustomInput
                    autoComplete="off"
                    placeholder={t('AppUserUnp')}
                    onChange={getOrgByUnp}
                />
            </Form.Item>
            <Form.Item
                label={t('AppUserOrgan')}
                name="nameUl"
                normalize={(word) => (word ? word : null)}
                rules={[
                    {
                        required: true,
                        min: 3,
                        max : 60,
                        message : t('validation:LengthErr')
                    }
                ]}
            >
                <CustomInput
                    autoComplete="off"
                    maxLength={150}
                    placeholder={t('AppUserOrgan')}
                />
            </Form.Item>
            <AddressInput
                isLegalEntityRB={isLegalEntityRB}
                address={user.address}
                disabled={isNotToChange}
                form={form}
                placeholder=''
            />
        </>
    )
}

export default Company
